// local imports
import openDownloadModal from "../modal/openDownloadModalScreen";
import openContentLockModal from "../common/content-lock";
import { sendDownloadEvent, sendYaMetrikaEvent } from "../analytics";

// constants
import DOWNLOAD_MONETIZED_GOALS from "../../../constants/monetized-goals";

// classes
import LocalStorage from "../../../classes/local-storage";

// utils
import relativeApiFetch from "../../../utils/relative-api-fetch";

function _isSecondDlEnabled() {
  const { secondDl = {} } = window.portal.downloadSettings || {};
  return secondDl.enabled && secondDl.downloadCount === LocalStorage.getClientDownloadsDailyCount();
}

function _isContentLockEnabled(buttonClickEvent) {
  const { contentLock = {} } = window.portal.downloadSettings || {};
  return (
    contentLock.enabled &&
    contentLock.downloadCount === LocalStorage.getClientDownloadsDailyCount() &&
    buttonClickEvent.target.getAttribute("data-id") !== "content-lock-soft-link"
  );
}

const _getDownloadButtonAttributes = element => ({
  categoryTitle: element.getAttribute("data-category-title"),
  categoryUid: element.getAttribute("data-category"),
  goal: element.getAttribute("data-goal"),
  icon: element.getAttribute("data-image"),
  name: element.getAttribute("data-name"),
  uid: element.getAttribute("data-uid"),
  url: element.href,
});

function _downloadSecondDl() {
  const { secondDl = {} } = window.portal.downloadSettings || {};
  const promoBrowserType = secondDl.links?.promoBrowserType;
  sendYaMetrikaEvent(DOWNLOAD_MONETIZED_GOALS.secondDl[promoBrowserType]);
  window.open(secondDl.links?.link, "_self");
}

function handleDownloadButtonsDownloading() {
  const softDownloadButtons = Array.from(document.querySelectorAll(".download-button"));
  softDownloadButtons.filter(Boolean).forEach((buttonElem) => {
    buttonElem.addEventListener("click", async (el) => {
      el.preventDefault();
      const buttonAttributes = _getDownloadButtonAttributes(buttonElem);

      if (_isContentLockEnabled(el)) {
        el.preventDefault();
        openContentLockModal({ buttonElem, buttonAttributes });
      } else if (_isSecondDlEnabled()) {
        _downloadSecondDl();
        LocalStorage.incrementClientDownloadsDailyCount();
      } else {
        const resRaw = await relativeApiFetch(buttonElem.href);
        const { downloadUrl, goal, type } = await resRaw.json();

        const event = new CustomEvent("download", {
          detail: {
            goal: buttonElem.dataset.goal || goal,
            softCategory: buttonElem.dataset.articleCategory,
            softIcon: buttonElem.dataset.image,
            softName: buttonElem.dataset.name,
            softUid: buttonElem.dataset.uid,
            softUrl: buttonElem.href,
          },
        });

        if (downloadUrl) {
          if (type === "remote" || downloadUrl.endsWith(".pdf")) {
            event.detail.isRemoteDownload = true;
            window.open(downloadUrl, "_blank");
          } else {
            window.open(downloadUrl, "_self");
          }

          document.dispatchEvent(event);
        }
      }
    });
  });

  document.addEventListener("download", (event) => {
    const isDownloadModalOpened = document.querySelector(".download-modal.show");

    if (!isDownloadModalOpened) {
      openDownloadModal(event.detail);
    }

    sendDownloadEvent(event.detail);
    LocalStorage.incrementClientDownloadsDailyCount();
  });
}

export default handleDownloadButtonsDownloading;